import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Step from '@material-ui/core/Step'
import StepContent from '@material-ui/core/StepContent'
import StepLabel from '@material-ui/core/StepLabel'
import Stepper from '@material-ui/core/Stepper'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import BillardConfigurationComponent from './BillardConfigurationComponent'
import PricingConfigurationComponent from './PricingConfigurationComponent'
import NavigationConfigurationComponent from './NavigationConfigurationComponent'

const styles = theme => ({
  root: {
    width: '100%'
  },
  gridSeparator: {
    paddingTop: theme.spacing.unit * 2
  },
  button: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  actionsContainer: {
    marginBottom: theme.spacing.unit * 2
  },
  resetContainer: {
    padding: theme.spacing.unit * 3
  }
})

function getSteps() {
  return ['Billard', 'Tarifs', 'Navigation']
}

export default withStyles(styles)(
  class DashpoolConfigurationStepper extends React.Component {
    static propTypes = {
      settings: PropTypes.object,
      updateSettingsStep: PropTypes.func.isRequired,
      updateTableTypeSettings: PropTypes.func.isRequired,
      updatePricing: PropTypes.func.isRequired,
      updateNavigationMenu: PropTypes.func.isRequired,
      completed: PropTypes.func.isRequired,
      classes: PropTypes.object
    }
    static defaultProps = {
      settings: {}
    }
    getStepContent(step) {
      const {
        settings,
        updateTableTypeSettings,
        updatePricing,
        updateNavigationMenu
      } = this.props
      switch (step) {
        case 0:
          return (
            <BillardConfigurationComponent
              tableTypes={settings.tableTypes}
              updateTableTypeSettings={updateTableTypeSettings}
            />
          )
        case 1:
          return (
            <PricingConfigurationComponent
              updatePricing={updatePricing}
              pricing={settings.pricing}
              tableTypes={settings.tableTypes}
            />
          )
        case 2:
          return (
            <NavigationConfigurationComponent
              updateNavigationMenu={updateNavigationMenu}
              menu={settings.menu}
            />
          )
        default:
          return null
      }
    }
    handleNext = () => {
      if (this.props.settings.activeStep > 3) return
      this.props.updateSettingsStep(this.props.settings.activeStep + 1)
      if (this.props.settings.activeStep === getSteps().length - 1) {
        this.props.completed(true)
      }
    }

    handleBack = () => {
      if (this.props.settings.activeStep < 1) return
      this.props.updateSettingsStep(this.props.settings.activeStep - 1)
    }

    render() {
      const { classes } = this.props
      const steps = getSteps()
      const { activeStep } = this.props.settings

      return (
        <Grid
          container
          alignItems="stretch"
          direction="column"
          justify="center">
          <Grid item xs={12}>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((label, index) => {
                return (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                    <StepContent>
                      {this.getStepContent(index)}
                      <Grid
                        className={classes.gridSeparator}
                        item
                        xs={10}
                        sm={8}
                        md={12}>
                        <Divider light />
                      </Grid>
                      <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center">
                        <Grid item>
                          <Button
                            disabled={activeStep === 0}
                            onClick={this.handleBack}
                            className={classes.button}>
                            Retour
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="raised"
                            color="primary"
                            onClick={this.handleNext}
                            className={classes.button}>
                            {activeStep === steps.length - 1
                              ? 'Terminé'
                              : 'Suivant'}
                          </Button>
                        </Grid>
                      </Grid>
                    </StepContent>
                  </Step>
                )
              })}
            </Stepper>
            {activeStep === steps.length && (
              <Paper square elevation={0} className={classes.resetContainer}>
                <Typography variant="title" gutterBottom>
                  Configuration Terminé
                </Typography>
              </Paper>
            )}
          </Grid>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/DashpoolConfiguration/DashpoolConfigurationStepper.js